import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhp, faWordpress, faReact, faHtml5, faJsSquare, faPython, faShopify } from "@fortawesome/free-brands-svg-icons";
import powerAutomateSvg from '../assets/svg/power-automate-svg.svg';
import wooCommerceSvg from '../assets/svg/woocommerce-svg.svg';
import FadeSection from "./utils/anim";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import BoxGlowing from "./ui/box-glowing";

const SkillCard = ({ icon , skillpercent , skillname, animdelay, classes }) => (
    
    <div className="max-w-[170px] w-full text-center">
        <FadeSection effect="fade-out" delay={animdelay}>
            
            <div className="rounded-3xl p-[40px_15px_30px] bg-[#140c1c] shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] border-transparent mb-[15px] transition-all duration-600 border-2">
                <BoxGlowing 
                blur = {0.5}
                borderWidth={3}
                spread={90}
                glow={true}
                disabled={false}
                proximity={64}
                inactiveZone={0.01}
            />
                <div className="leading-none svg-image mt-0 mx-auto mb-8">
                    {icon}
                </div>
                <div className="text-white text-xl font-bold transition-all duration-400 ease-in-out delay-0">{skillpercent}</div>
            </div>
            </FadeSection>
            <FadeSection effect="fade-out" delay={animdelay}>
                <p className={`${classes} text-lg`}>{skillname}</p>                
            </FadeSection>
    </div>
   
    
    );

function Skills({ lightMode }){

    const allSkills = [
        {
            icon: (<FontAwesomeIcon className="third-color" size="6x" icon={faPhp}/>) ,
            skillpercent: "95%",
            skillname: "Php",
            animDelay: "delay-75"
        },
        {
            icon: (<FontAwesomeIcon className="third-color" size="6x" icon={faWordpress}/>),
            skillpercent: "98%",
            skillname: "Wordpress",
            animDelay: "delay-100"
        },
        {
            icon: (<FontAwesomeIcon className="third-color" size="6x" icon={faReact}/>) ,
            skillpercent: "90%",
            skillname: "React JS",
            animDelay: "delay-100"
        },
        {
            icon: (<FontAwesomeIcon className="third-color" size="6x" icon={faPython}/>) ,
            skillpercent:"78%",
            skillname:"Python",
            animDelay: "delay-150"
        },
        {
            icon: (<FontAwesomeIcon className="third-color" size="6x" icon={faHtml5}/>),
            skillpercent: "98%",
            skillname: "Html5",
            animDelay: "delay-150"
        },
        {
            icon:  (<FontAwesomeIcon className="third-color" size="6x" icon={faJsSquare}/>),
            skillpercent: "92%",
            skillname: "JavaScript",
            animDelay: "delay-200"
        },
        {
            icon:  (<FontAwesomeIcon className="third-color" size="6x" icon={faDatabase}/>),
            skillpercent: "85%",
            skillname: "MySQL, MongoDB",
            animDelay: "delay-200"
        },
        {
            icon:  (<FontAwesomeIcon className="third-color" size="6x" icon={faShopify}/>),
            skillpercent: "70%",
            skillname: "Shopify",
            animDelay: "delay-200"
        },
        {
            icon:  (<img src={wooCommerceSvg} alt="Logo" />),
            skillpercent: "65%",
            skillname: "WooCommerce",
            animDelay: "delay-300"
        },
        {
            icon: (<img src={powerAutomateSvg} alt="Logo" />) ,
            skillpercent:"90%",
            skillname:"Power Automate",
            animDelay: "delay-300"
        },
        

    ];

    return(
    <>
    <div className={`skills pb-8 ${lightMode ? "bg-gray-200": "bg-gray-800"} min-h-full`}>
        <div className="max-w-7xl mx-auto">
            <FadeSection effect="fade-in-down">
            <div className="px-4 min-h-full pt-10 pb-7 ">
                <h2 className={`${lightMode ? "skills-title-light" : "skills-title"} text-4xl text-left font-bold text-white mb-12`}>Skills</h2>
            </div>
            </FadeSection>
            <div className="h-full">
                <div className="flex flex-wrap items-center justify-center gap-y-5 gap-x-8">
                   {allSkills.map((skill ,index) =>(
                    <SkillCard
                        key={index}
                        icon={skill.icon}
                        skillpercent={skill.skillpercent}
                        skillname={skill.skillname}
                        animdelay = {skill.animDelay}
                        classes={lightMode ? "text-black font-medium" : "text-white"}
                    />
                   ))}
                </div>
            </div>
        </div>
    </div>
    </>
    
);
}

export default Skills;